import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
  Badge,
  Button,
  Card,
  CardBody,
  DropdownMenu,
  DropdownToggle,
  Input,
  DropdownItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import { API_Logs } from '../../../../../../constants/APIs';
import moment from 'moment';
import Pagination from '../../../../../../containers/pages/Pagination';
import IntlMessages from '../../../../../../helpers/IntlMessages';

function Logs({ logType, visible, label, toggle, id, locale }) {
  const [logList, setLogList] = useState([]);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(10);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${API_Logs}/${id}`,
    }).then((res) => {
      const data = Array.isArray(res?.data) ? res.data : [];

      setTotalItems(data.length);
      setTotalPages(
        data.length === 0 ? 0 : Math.ceil(data.length / SelectedPageSize)
      );
      setLogList(data);
    });
  }, [id, currentPage, SelectedPageSize]);

  const onChangePage = (page) => {
    setcurrentPage(page);
  };

  return (
    <Fragment>
      <style>{`
.logs-modal .modal-content {
  overflow: hidden;
}

.logs-modal .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 200px);
  padding: 24px;
}
.logs-modal .logs {
  overflow: visible;
  max-height: none;
}

.logs-modal .card {
  overflow: visible !important;
}
      `}
      </style>

      <Modal isOpen={visible} toggle={toggle} modalClassName="logs-modal" style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>{label}</ModalHeader>
        <ModalBody>
          <Row className="logs">
            <Colxx xxs="12">
              <div className="float-md-right">
                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                <UncontrolledDropdown className="d-inline-block">
                  <DropdownToggle caret color="outline-dark" size="xs">
                    {SelectedPageSize}
                  </DropdownToggle>
                  <DropdownMenu right>
                    {pageSizes.map((size, index) => {
                      return (
                        <DropdownItem
                          key={index}
                          onClick={() => changePageSize(size)}
                        >
                          {size}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Colxx>

            <Colxx xxs="12">
              {Array.isArray(logList) &&
                logList.length > 0 &&
                logList.map((m, index) => {
                  const assistantInstructions =
                    m.content?.AssistantInstructions ||
                    m.content?.assistantInstructions ||
                    {};

                  return (
                    <Row className="mb-3" key={index}>
                      <Colxx xxs="12" xs="3">
                        <Fragment>
                          Version On:
                          <br />
                          {moment(m.date).format('MMM DD, YYYY h:mm a')}
                          <br />
                          <br />
                          {m.action !== undefined && (
                            <Fragment>
                              Action:
                              <br />
                              <span
                                style={{
                                  color: `${m.action.includes('Delete') ? 'red' : 'green'
                                    }`,
                                }}
                              >
                                {m.action}
                              </span>
                            </Fragment>
                          )}
                        </Fragment>
                      </Colxx>

                      <Colxx xxs="12" xs="9">
                        <Card
                          className="d-flex mb-3"
                          key={`faqItem_${index}`}
                          style={{ borderRadius: '25px' }}
                        >
                          <CardBody className="logsBody">
                            <Row className="mb-3">
                              <Colxx xxs="12" className="mb-2">
                                <b>Name</b>
                              </Colxx>
                              <Colxx xxs="12" className="ml-0">
                                {m.content.Name}
                              </Colxx>
                            </Row>
                            {m.content?.Instructions && (
                              <Row className="mb-3">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Task Overview</b>
                                </Colxx>
                                <Colxx xxs="12">
                                  {m.content.Instructions}
                                </Colxx>
                              </Row>
                            )}
                            {assistantInstructions.ConversationHandling && (
                              <Row className="mb-3">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Conversation Handling</b>
                                </Colxx>
                                <Colxx xxs="12">
                                  {assistantInstructions.ConversationHandling}
                                </Colxx>
                              </Row>
                            )}
                            {assistantInstructions.TonePersonality && (
                              <Row className="mb-3">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Tone & Personality</b>
                                </Colxx>
                                <Colxx xxs="12">
                                  {assistantInstructions.TonePersonality}
                                </Colxx>
                              </Row>
                            )}
                            {assistantInstructions.SystemRules && (
                              <Row className="mb-3">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Safety & System Rules</b>
                                </Colxx>
                                <Colxx xxs="12">
                                  {assistantInstructions.SystemRules}
                                </Colxx>
                              </Row>
                            )}
                            <Row className="mb-3">
                              <Colxx xxs="12" className="mb-2">
                                <b>Status:</b>
                                {m.content.Status !== 'Active' ? (
                                  <span color="red" className="ml-1">
                                    {m.content.Status}
                                  </span>
                                ) : (
                                  <span color="green" className="ml-1">
                                    {m.content.Status}
                                  </span>
                                )}
                              </Colxx>
                            </Row>

                            <Row className="mb-3">
                              <Colxx xxs="12" className="mb-2">
                                <b>OpenAiModel: </b>
                                <span className="ml-1">
                                  {m.content.OpenAiModel}
                                </span>
                              </Colxx>
                            </Row>

                            <Row className="mb-3">
                              <Colxx xxs="12" className="mb-2">
                                <b><IntlMessages id='dashboards.displayOrder' /> : </b>
                                <span className="ml-1">
                                  {m.content.DisplayOrder}
                                </span>
                              </Colxx>
                            </Row>

                            {m.content.FlowTraningData !== undefined &&
                              m.content.FlowTraningData !== null && (
                                <Row className="mb-2">
                                  <Colxx xxs="12" className="mb-2">
                                    <b>FlowTraningData:</b>
                                    {m.content.FlowTraningData.IsEnabled ? (
                                      <span color="red" className="ml-1">
                                        true
                                      </span>
                                    ) : (
                                      <span color="green" className="ml-1">
                                        false
                                      </span>
                                    )}
                                  </Colxx>
                                </Row>
                              )}

                            {m.content.InvokeApi !== undefined &&
                              m.content.InvokeApi !== null && (
                                <Row className="mb-2">
                                  <Colxx xxs="12" className="mb-2">
                                    <b>InvokeApi: </b>
                                    {m.content.InvokeApi?.IsEnabled ? (
                                      <span color="red" className="ml-1">
                                        true
                                      </span>
                                    ) : (
                                      <span color="green" className="ml-1">
                                        false
                                      </span>
                                    )}
                                  </Colxx>
                                </Row>
                              )}

                            {m.content.InvokeApi !== undefined &&
                              m.content?.InvokeApi !== null &&
                              m.content?.InvokeApi?.IsEnabled && (
                                <Row className="mb-2">
                                  <Colxx xxs="12" className="mb-1">
                                    {m.content?.InvokeApi?.JSON !== undefined &&
                                      Array.isArray(m.content?.InvokeApi?.JSON) &&
                                      m.content.InvokeApi.JSON.length > 0 &&
                                      m.content?.InvokeApi?.JSON.map(
                                        (m, index) => (
                                          <Fragment key={index}>
                                            <Colxx md="12" className="mb-2">
                                              <Input
                                                type="text"
                                                value={m}
                                              ></Input>
                                            </Colxx>
                                          </Fragment>
                                        )
                                      )}
                                  </Colxx>
                                </Row>
                              )}

                            {m.content.Collection !== undefined &&
                              m.content.Collection !== null &&
                              m.content.Collection.length > 0 && (
                                <Row className="mb-2">
                                  <Colxx xxs="12" className="mb-2">
                                    <b>Collection: </b>
                                    <span>{m.content.Collection[0]}</span>
                                  </Colxx>
                                </Row>
                              )}

                            {m.comments !== undefined &&
                              m.comments !== null &&
                              m.comments !== '' && (
                                <Row>
                                  <Colxx xxs="12" className="mb-2">
                                    <b>Comments</b>
                                  </Colxx>
                                  <Colxx xxs="12" className="ml-0">
                                    {m.comments}
                                  </Colxx>
                                </Row>
                              )}
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  );
                })}
            </Colxx>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Pagination
            currentPage={currentPage}
            totalPage={TotalPages}
            onChangePage={(i) => onChangePage(i)}
          />
          <Button color="secondary" onClick={toggle}>
            Back
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Logs));